module.exports = __webpack_public_path__ + "img/mapa_pt.8913e46d.jpg";